<template>
    <v-menu
        v-model="menu"
        transition="scale-transition"
        offset-y
        :max-width="menuWidth"
        :close-on-content-click="false"
        :close-on-click="false"
    >
    <template v-slot:activator="{ on }">
        <v-text-field
        v-bind="textFieldProps"
        :disabled="disabled"
        :loading="loading"
        :label="label"
        :value="formattedTime"
        v-on="on"
        readonly
        >
        <template v-slot:progress>
            <slot name="progress">
            <v-progress-linear color="primary" indeterminate absolute height="2"></v-progress-linear>
            </slot>
        </template>
        </v-text-field>
    </template>

    <v-card>
        <v-card-text class="px-0 py-0">
        <v-tabs fixed-tabs v-model="activeTab">
            <v-tab key="clock-start">
            <slot name="dateIcon">
                <v-icon>mdi-clock-start</v-icon>
            </slot>
            </v-tab>
            <v-tab key="clock-end" >
            <slot name="timeIcon">
                <v-icon>mdi-clock-end</v-icon>
            </slot>
            </v-tab>
            <v-tab-item key="clock-start">
                <v-time-picker
                  v-if="min_max_formated" 
                  ref="clockStart"
                  v-model="timeStart" 
                  format="24hr" 
                  :max="timeEnd"
                  v-bind="timeProps"
                  scrollable
                  @click:minute="goToTimeEnding()"
                ></v-time-picker>
                <v-time-picker 
                  v-else
                  ref="clockStart"
                  v-model="timeStart" 
                  format="24hr" 
                  v-bind="timeProps"
                  scrollable
                  @click:minute="goToTimeEnding()"
                ></v-time-picker>
              </v-tab-item>
              <v-tab-item key="clock-end">
                <v-time-picker 
                  ref="clockEnd"
                  v-model="timeEnd"
                  :min="timeStart" 
                  v-bind="timeProps"
                  v-if="min_max_formated"
                  format="24hr" 
                  scrollable
                ></v-time-picker>
                <v-time-picker 
                  v-else
                  ref="clockEnd"
                  v-model="timeEnd"
                  v-bind="timeProps"
                  format="24hr" 
                  scrollable
                ></v-time-picker>
            </v-tab-item>
        </v-tabs>
        </v-card-text>
        <v-card-actions>
        <v-spacer></v-spacer>
        <slot name="actions" :parent="this">
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                <v-btn
                    ripple
                    outlined
                    icon
                    color="darkRed"
                    @click="cancelEvent()"
                    dark
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                </template>
                <span>Cancelar</span>
            </v-tooltip>

            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                <v-btn
                    ripple
                    outlined
                    icon
                    color="bluePcm"
                    @click="okHandler()"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ml-2"
                >
                    <v-icon>mdi-check</v-icon>
                </v-btn>
                </template>
                <span>Confirmar</span>
            </v-tooltip>
        </slot>
        </v-card-actions>
    </v-card>
    </v-menu>
</template>
    
    <script>
    // import moment from 'moment'
    const DEFAULT_MENU_WIDTH = 290
    const DEFAULT_CLEAR_TEXT = 'CLEAR'
    const DEFAULT_OK_TEXT = 'OK'
    const DEFAULT_MIN_MAX_CLOCK = "true";
  
  
    export default {
      name: 'v-pcmtime-picker',
      model: {
        prop: 'time',
        event: 'input'
      },
      props: {
        time: {
          type: [Date, String, Object],
          default: null
        },
        disabled: {
          type: Boolean
        },
        loading: {
          type: Boolean
        },
        label: {
          type: String,
          default: ''
        },
        menuWidth: {
          type: Number,
          default: DEFAULT_MENU_WIDTH
        },
        clearText: {
          type: String,
          default: DEFAULT_CLEAR_TEXT
        },
        okText: {
          type: String,
          default: DEFAULT_OK_TEXT
        },
        textFieldProps: {
          type: Object
        },
        timeProps: {
          type: Object
        },
        min_max: {
          type: String,
          default: DEFAULT_MIN_MAX_CLOCK
        },
      },
      data:() => ({
        timeStart: null,
        timeEnd: null,
        activeTab: 0,
        display: false,
        menu:false,
      }),
      created(){
        this.timeStart = "00:00"
        this.timeEnd = "23:59"
      },
      computed: {
        min_max_formated(){
          if(this.min_max == 'false'){
            return false
          }else{
            return true
          }
        },
        selectedTime(){
          let timeRange = {
            timeStart: this.timeStart,
            timeEnd: this.timeEnd,
          }
          return timeRange
        },
        formattedTime(){
          if (this.timeStart != null && this.timeEnd != null){
            return `${this.timeStart} - ${this.timeEnd}`
          }
          return '00:00' 
        },
       
      },
      methods: {
        cancelEvent() {
          if(this.activeTab == 0){
            if (this.$refs.clockStart) {
              this.$refs.clockStart.selectingHour = true
            }
            this.menu = false
          }else{
            if (this.$refs.clockEnd) {
              this.$refs.clockEnd.selectingHour = true
            }
            this.activeTab = 0
          }
          this.$emit('input', null)
        },
        okHandler() {
          this.$emit('input', this.selectedTime)
          this.resetPicker()
          this.$refs.clockStart.selectingHour = true
          this.$refs.clockEnd.selectingHour = true
        },
        resetPicker() {
          this.menu = false
        },
        goToTimeEnding(){
          this.activeTab = 1
        }
      },
      watch: {
      }
    }
    </script>